import { errorHandler, notifyMessageCreator, loadersSlice, gridSlice } from 'Modules'
import { RequestParams, ResponseCatalog } from 'Models'
import { call, put, select, takeLatest } from 'typed-redux-saga'
import {
	ChannelStructureNS,
	channelStructureSlice,
	channelStructureSelector,
	channelStructureApi,
	ChannelStructureModel,
} from 'Pages/referenceBooks'
import { Deserialize } from 'cerialize'

function* getAll(action: ChannelStructureNS.GetAll) {
	try {
		yield* put(gridSlice.actions.setLoading(true))
		const { params, clear, callback } = action.payload
		const { page, per_page, query, ...fields } = params
		const requestParams = new RequestParams(clear ? 1 : page, per_page, query, fields)
		if (clear) {
			yield* put(channelStructureSlice.actions.clearAll())
		}
		const res = yield* call(channelStructureApi.getAll, requestParams)
		const items = new ResponseCatalog<ChannelStructureModel>(res)
		items.entries = res.entries.map(
			(item): ChannelStructureModel => Deserialize(item, ChannelStructureModel)
		)
		if (!clear) {
			const oldItems = yield* select(channelStructureSelector.getAll)
			items.entries = oldItems.entries.concat(items.entries)
		}
		yield* put(channelStructureSlice.actions.setAll(items))
		yield* put(channelStructureSlice.actions.setRequestParams(requestParams))
		callback?.()
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(gridSlice.actions.setLoading(false))
	}
}

function* getExcel(action: ChannelStructureNS.GetExcel) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		yield* call(channelStructureApi.getExcel, action.payload.params)
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* call(notifyMessageCreator, 'common.report_send.success')
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* call(errorHandler, error)
	}
}

export function* channelStructureSaga() {
	yield* takeLatest(channelStructureSlice.actions.getAll.type, getAll)
	yield* takeLatest(channelStructureSlice.actions.getExcel.type, getExcel)
}
